
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, float64_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ofArray, map, tryFind } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { reactElement, reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { SegmentedControl } from "./SegmentedControl.js";
import { iterate, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { toArray, unwrap, map as map_1, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { NumberInput } from "./Input.js";

export class Dimension extends Record {
    constructor(WidthMm, HeightMm, MarginMm) {
        super();
        this.WidthMm = WidthMm;
        this.HeightMm = HeightMm;
        this.MarginMm = MarginMm;
    }
}

export function Dimension_$reflection() {
    return record_type("Components.DimensionInput.Dimension", [], Dimension, () => [["WidthMm", float64_type], ["HeightMm", float64_type], ["MarginMm", float64_type]]);
}

export function DimensionInput(props) {
    let elems_1, Label, Options, Value_2, elems;
    const t = useTranslation()[0];
    const presetOf = (dimension) => tryFind((tupledArg) => {
        if (tupledArg[0] === dimension.WidthMm) {
            return tupledArg[1] === dimension.HeightMm;
        }
        else {
            return false;
        }
    }, props.Presets);
    let patternInput_1;
    const initial = presetOf(props.Value) == null;
    patternInput_1 = reactApi.useState(initial);
    const setIsCustom = patternInput_1[1];
    const isCustom = patternInput_1[0] ? true : (presetOf(props.Value) == null);
    const formatPreset = (tupledArg_1) => (`${tupledArg_1[0]} × ${tupledArg_1[1]} mm`);
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_1 = [createElement(SegmentedControl, (Label = t("labels.settings.size"), (Options = toList(delay(() => append(map((preset) => ({
        Label: formatPreset(preset),
        TestId: `${props.TestId}-preset-${preset[0]}x${preset[1]}`,
        Value: formatPreset(preset),
    }), props.Presets), delay(() => singleton({
        Label: t("labels.settings.custom_size"),
        TestId: concat(props.TestId, ..."-preset-custom"),
        Value: "custom",
    }))))), (Value_2 = (isCustom ? "custom" : defaultArg(map_1(formatPreset, presetOf(props.Value)), "custom")), {
        ComponentState: props.ComponentState,
        Label: unwrap(Label),
        OnChange: (value_4) => {
            if (value_4 === "custom") {
                setIsCustom(true);
            }
            else {
                const matchValue = tryFind((preset_1) => (formatPreset(preset_1) === value_4), props.Presets);
                if (matchValue == null) {
                }
                else {
                    const width_2 = matchValue[0];
                    const height_2 = matchValue[1];
                    setIsCustom(false);
                    props.OnChange(new Dimension(width_2, height_2, props.Value.MarginMm));
                }
            }
        },
        Options: Options,
        TestId: concat(props.TestId, ..."-presets"),
        Value: Value_2,
    })))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "gap-3"])], (elems = [createElement(NumberInput, {
        ComponentState: isCustom ? props.ComponentState : "disabled",
        Label: t("labels.settings.width_mm"),
        MaxValue: 300,
        OnChange: (value_6) => {
            iterate((width_3) => {
                let bind$0040_1;
                props.OnChange((bind$0040_1 = props.Value, new Dimension(width_3, bind$0040_1.HeightMm, bind$0040_1.MarginMm)));
            }, toArray(value_6));
        },
        TestId: concat(props.TestId, ..."-width"),
        Value: props.Value.WidthMm,
    }), createElement(NumberInput, {
        ComponentState: isCustom ? props.ComponentState : "disabled",
        Label: t("labels.settings.height_mm"),
        MaxValue: 300,
        OnChange: (value_7) => {
            iterate((height_3) => {
                let bind$0040_2;
                props.OnChange((bind$0040_2 = props.Value, new Dimension(bind$0040_2.WidthMm, height_3, bind$0040_2.MarginMm)));
            }, toArray(value_7));
        },
        TestId: concat(props.TestId, ..."-height"),
        Value: props.Value.HeightMm,
    }), createElement(NumberInput, {
        ComponentState: props.ComponentState,
        Label: t("labels.settings.margin_mm"),
        MaxValue: 50,
        OnChange: (value_8) => {
            iterate((margin) => {
                let bind$0040_3;
                props.OnChange((bind$0040_3 = props.Value, new Dimension(bind$0040_3.WidthMm, bind$0040_3.HeightMm, margin)));
            }, toArray(value_8));
        },
        TestId: concat(props.TestId, ..."-margin"),
        Value: props.Value.MarginMm,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

